;(function($, undefined){
    var rnn, log;

    /* SELF SERVICE STUFF */
    function init_expander_toggles() {
        /* Forgive me if you hate this.
        This is an insanely quick attempt at making a few expander toggles (as above) - they use their parent's class to toggle on the form we want to show and toggle themselves off. Just set style="display: none on form fields initially"*/
        var expanderDiv = $(".ss_formExpanders");
        expanderDiv.show();
        expanderDiv.find("label").each(function() {
            $(this).children().click(function(e) {
                var theClass = "."+($(this).parent().attr('class'));
                $(theClass).toggle(); /*get the className and toggle other elements of it, including self - show others hide self*/
                /*If they're all hidden, hide the parent too*/
                expanderDiv.before($(theClass)); //put it before the toggles for interaction.
                if(expanderDiv.children(":hidden").length === expanderDiv.children().length) {
                    expanderDiv.hide();
                }
                e.preventDefault();
            });
        });
    }

    /* This was (also) done pretty quick, TODO to move this and generify */
    function init_ajax_slug_check(originalSlug) {
        //This will come in handy in order to update all related elements.

        var slugRelatedElements = $("form .slug");
        var slugInputElement = slugRelatedElements.find("input");
        var helpElement = slugRelatedElements.find(".helpBubble");

        var originalHelpHTML = helpElement
                                .clone()
                                .find('strong').remove().end()
                                .html();

        var dynamicUrlLink = $('#dynamic-url-link');

        slugInputElement
        .focusin(function(){
            if ($(this).val().length < 1) {
                var nameField = $("#id_business_name").val();
                $(this).val(rnn.modules.utilities.slugify(nameField));
            }
        });

        slugInputElement
        .focusout(function() {
            var $theInput = $(this);
            var $groupDiv = $(this).closest(".control-group");

            // Clean up the slug value.
            $theInput.val($.trim($theInput.val())); //in case they only put in a slug
            $theInput.val( rnn.modules.utilities.slugify( $theInput.val() ) ); //Change to valid slugs.
            var inputText = $theInput.val(); //Now it's fixed and visible, we store it.

            dynamicUrlLink.text(inputText || 'your-business-name');

            var callUrl = "/businesses/" + inputText + "/available/";

            function clearStatus() {
                // Clear any stylings on update.
                $groupDiv.removeClass("error")
                        .removeClass("success")
                        .removeClass("busy");
                helpElement.removeClass("error")
                        .html(originalHelpHTML);
            }

            // Add spinner during processing.
            $groupDiv.addClass("busy");

            if (inputText.length > 0) {
                if (inputText == originalSlug) {
                    clearStatus();
                    $groupDiv.addClass("success")
                            .removeClass("busy");
                } else {
                    $.ajax({ url: callUrl, type: 'GET', timeout: 20000,
                        error: function(){
                            clearStatus();
                            $groupDiv.removeClass("busy");
                        },
                        success: function(data){
                            clearStatus();
                            if (data == 'true') {
                                //set stylings and text
                                $groupDiv.addClass("success")
                                        .removeClass("busy");
                            } else {
                                //set stylings and text with error
                                $groupDiv.addClass("error")
                                        .removeClass("busy");
                                helpElement.addClass("error");
                                //if (NOT originalHelpHTML contains a strong tag) {
                                    helpElement.html(originalHelpHTML+"<strong>- This web address is not available, please try another.</strong>");
                                //};
                            }
                        }
                    });
                }
            } else {
                clearStatus();
                $theInput.removeClass("busy");
            }; //end input length check
        }); //end focusout
    } //function init_ajax_slug_check

    // Dodgy hack to avoid removing compress tags.
    var originalSlug;
    function updateSlug(slug) {
        this.originalSlug = slug;
    }

    function init_category_filter_select() {

        $('[data-filter-select]').each(function() {
            var $field = $(this),
                options = $field.data().filterSelect;
            $field.filterSelect(options);
        });

    }

    // Initialise Buisnesses
    function initBusinesses() {
        // initSearchForms();
        // initMaps();

        // Self Service
        init_expander_toggles();
        init_ajax_slug_check(this.originalSlug);
        init_category_filter_select();

        // updateSlug: updateSlug
    }

    rnn = window.rnn;
    log = rnn.logging.log;

    // maps = rnn.modules.maps;

    rnn.modules.register('businesses', {
        init: initBusinesses,
        updateSlug: updateSlug
    });

})(jQuery);
